export const userAccess = {
  computed: {
    entities () {
      return ['ad_planner']
    },
    adminRoles () {
      return ['promo.admin', 'pce-admin', 'jbg-admin']
    },
    user () {
      return this.$auth.user
    },
    userGroups () {
      return this.$auth.userGroups || []
    },
    userPermissions () {
      return this.$auth.permissions || []
    },
    userRelatedParties () {
      return this.$store.getters.userRelatedParties
    },
    promoCategories () {
      return this.$store.getters.promoCategories
    },
    categoryManagers () {
      return this.$store.getters.categoryManagers
    },
    billingModes () {
      return this.$store.getters.billingModes
    },
    userAdGroupIds () {
      return this.userRelatedParties.flatMap(party => {
        return (party?.party_type_constant === 'AD_GROUP')
          ? party.id
          : []
      })
    },
    hasReadAccess () {
      const readScopes = this.entities.map(entity => `${entity}:read`)
      return readScopes.every(scope => this.userPermissions.includes(scope))
    },
    hasPortalAccess() {
      if ((this.$auth.tenant === 'alliance-retail-group') && (process.env.NODE_ENV === 'production') && this.noProdAccess) {
        return false
      }
      return !this.userPermissions.includes('ad_planner:no_access') && this.hasReadAccess
    },
    userAccessiblePortals() {
      const portals = ['ad_planner', 'customer', 'promo', 'item', 'billing', 'tpr', 'partner']
      const isProd = process.env.NODE_ENV === 'production'

      return portals.filter(portal => {
        let readScope = `${portal}:read`
        if (portal === 'billing') {
          readScope = 'billing_batch:read'
        } else if (portal === 'customer') {
          readScope = 'party:read'
        }
        else if (portal === 'tpr') {
          readScope = 'tpr_batch:read'
        }
        else if (portal === 'partner') {
          readScope = 'document:read'
        }
        const canRead = this.hasScope(readScope)
        if (!canRead) return false

        // Hard deny in all envs
        if (this.hasScope(`${portal}:no_access`)) return false

        // Deny in prod only (dev allowed) if they have the prod-block flag
        if (isProd && this.hasScope(`${portal}:no_access_prod`)) return false

        return true
      })
    },
    noProdAccess() {
      return this.userPermissions.includes('ad_planner:no_access_prod')
    },
    hasWriteAccess () {
      return this.writePermissions.every(scope => this.userPermissions.includes(scope))
    },
    writePermissions () {
      const actions = ['create', 'read', 'update']
      return this.entities.flatMap(entity => {
        return actions.map(action => `${entity}:${action}`)
      })
    },
    isAdmin () {
      return this.adminRoles.some(role => this.userGroups.includes(role)) || this.isARGAdmin
    },
    isARGAdmin () {
      return (this.$auth.tenant === 'alliance-retail-group') && ['arg-admin', 'arg-support'].some(role => this.userGroups.includes(role))
    },
    isIproAdmin () {
      return (this.$auth.tenant === 'alliance-retail-group') && this.userGroups.includes('ipro-admin')
    },
    hasStatusAdminAccess () {
      return this.isAdmin || this.userPermissions.includes('ad_planner:status_admin')
    },
    limitAccessByRelatedAdGroups () {
      return !this.isAdmin && this.userGroups.includes('promo.coordinator')
    },
    limitAccessByRelatedVendors () {
      return !this.isAdmin && this.userPermissions.includes('promo:related_vendors')
    },
    limitAccessByRelatedSubvendors () {
      return !this.isAdmin && this.userPermissions.includes('promo:related_subvendors')
    },
    useAdGroups() {
      // determines whether ads are to be created with ad groups or stores
      return this.$auth.tenant !== 'jbg'
    }
  },
  methods: {
    hasScope (scope) {
      return this.userPermissions.includes(scope)
    }
  }
}